"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _icons = require("../../icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DateInput = function DateInput(_ref) {
  var handleClickDateInput = _ref.handleClickDateInput,
      showIcon = _ref.showIcon,
      tabIndex = _ref.tabIndex,
      isFocus = _ref.isFocus,
      value = _ref.value,
      placeholder = _ref.placeholder,
      handleChangeDate = _ref.handleChangeDate,
      dateFormat = _ref.dateFormat,
      isSingle = _ref.isSingle,
      onFocus = _ref.onFocus,
      name = _ref.name,
      nonFocusable = _ref.nonFocusable,
      fromDate = _ref.fromDate,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      setSelectedInput = _ref.setSelectedInput;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      formattedDate = _useState2[0],
      setFormattedDate = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      disablePrev = _useState4[0],
      setDisablePrev = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      disableNext = _useState6[0],
      setDisableNext = _useState6[1];

  (0, _react.useEffect)(function () {
    if (value) {
      var text = value.format('ddd, DD MMM');

      if (dateFormat) {
        text = value.format(dateFormat);
      }

      setFormattedDate(text);

      if (minDate && (0, _dayjs.default)(minDate).add(1, 'day').isAfter(value, 'date') || name === 'END_DATE' && value.isBefore(fromDate.add(1, 'day'), 'date')) {
        setDisablePrev(true);
      } else {
        setDisablePrev(false);
      }

      if (maxDate && (0, _dayjs.default)(maxDate).subtract(1, 'day').isBefore(value, 'date')) {
        setDisableNext(true);
      } else {
        setDisableNext(false);
      }
    } else {
      setFormattedDate(null);
    }
  }, [value, fromDate, dateFormat, maxDate, minDate, name]);

  function prevDate(e) {
    e.stopPropagation();
    handleChangeDate('prev', value);
  }

  function nextDate(e) {
    e.stopPropagation();
    handleChangeDate('next', value);
  }

  function onDateInputFocus() {
    if (onFocus) onFocus(name);
    setSelectedInput(name === 'START_DATE' ? 'from' : name === 'END_DATE' ? 'to' : '');
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('date', {
      'is-focus': isFocus,
      'is-single': isSingle
    }),
    role: "button",
    tabIndex: nonFocusable ? '-1' : tabIndex,
    onClick: handleClickDateInput,
    onFocus: onDateInputFocus,
    id: name === 'START_DATE' ? 'start-date-input-button' : name === 'END_DATE' ? 'end-date-input-button' : ''
  }, showIcon && /*#__PURE__*/_react.default.createElement(_icons.DateRange, {
    color: "primary",
    style: {
      marginRight: '.2rem'
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "selected-date"
  }, formattedDate || /*#__PURE__*/_react.default.createElement("div", {
    className: "date-placeholder"
  }, placeholder)), formattedDate && /*#__PURE__*/_react.default.createElement("div", {
    className: "change-date-group"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "btn-outline change-date-button",
    onClick: prevDate,
    tabIndex: nonFocusable ? '-1' : '0',
    disabled: disablePrev
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowBackIos, {
    color: "secondary"
  })), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "btn-outline change-date-button",
    onClick: nextDate,
    tabIndex: nonFocusable ? '-1' : '0',
    disabled: disableNext
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowForwardIos, {
    color: "secondary"
  }))));
};

DateInput.propTypes = {
  handleClickDateInput: _propTypes.default.func,
  showIcon: _propTypes.default.bool,
  tabIndex: _propTypes.default.string,
  isFocus: _propTypes.default.bool,
  value: _propTypes.default.instanceOf(Date),
  placeholder: _propTypes.default.string,
  handleChangeDate: _propTypes.default.func,
  dateFormat: _propTypes.default.string,
  isSingle: _propTypes.default.bool,
  onFocus: _propTypes.default.func,
  name: _propTypes.default.string,
  nonFocusable: _propTypes.default.bool,
  fromDate: _propTypes.default.instanceOf(Date),
  minDate: _propTypes.default.instanceOf(Date),
  maxDate: _propTypes.default.instanceOf(Date)
};
DateInput.defaultProps = {
  handleClickDateInput: function handleClickDateInput() {},
  showIcon: false,
  tabIndex: '',
  isFocus: false,
  value: null,
  placeholder: null,
  handleChangeDate: function handleChangeDate() {},
  dateFormat: '',
  isSingle: false,
  onFocus: function onFocus() {},
  name: '',
  nonFocusable: false,
  fromDate: null,
  minDate: null,
  maxDate: null
};
var _default = DateInput;
exports.default = _default;